export default __webpack_public_path__ + "static/media/japveerSingh.96ac5268.jpg";